<!-- MODAL Agregar usuario -->
<div mdbModal #AddEditMixtura="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <div class="modal-content">
      <form [formGroup]="formHeader" (ngSubmit)="AgregarEditarMixtura(); AddEditMixtura.hide();">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">Agregar</h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="AddEditMixtura.hide()"><span aria-hidden="true">×</span></button>
        </div>
        <div class="modal-body">
          <div class="container">
            <div class="row">
              <div class="col">
                <h5 class="modal-title w-100 text-left" id="myModalLabel">Datos de la mixtura</h5>
              </div>
            </div>
            <br />
            <div class="row">
              <div class="col">
                <div class="md-form">
                  <input formControlName="nombre" placeholder="Descripción" class="form-control" type="text"
                    id="anombre" value="" maxLength="50" required #anombre />
                  <label for="nombre">Descripción</label>
                  <div
                    *ngIf="formHeader.get('nombre').invalid && (formHeader.get('nombre').dirty || formHeader.get('nombre').touched)">
                    <mdb-error *ngIf="formHeader.get('nombre').hasError('required')">La Descripción es
                      requerido.</mdb-error>
                    <mdb-error *ngIf="formHeader.get('nombre').hasError('maxlength')">La Descripción no puede superar
                      los 50 caracteres.</mdb-error>
                    <mdb-error *ngIf="formHeader.get('nombre').hasError('minlength')">La Descripción debe tener como
                      mínimo 5 caracteres.</mdb-error>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer justify-content-between">
          <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
            (click)="CerrarAgregarEditarMixtura();" mdbWavesEffect>Cerrar</button>
          <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect type="submit"
            [disabled]="formHeader.invalid">Guardar</button>
        </div>
      </form>
    </div>
  </div>
</div>